export default getText => key =>
  ({
    today: getText('Today', 'Home_Tabs_Appointments_Header'),
  }[key])
